// extracted by mini-css-extract-plugin
module.exports = {"CardContainer":"CardContainer_7qUPK"};